import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./PubMedSearchIndex.css";
import PubMedAbstractsAnswerDisplayString from "./PubMedAbstractsAnswerDisplayString";
import {  isEqual } from 'underscore'

class PubMedRightGenAIAbstractsAnswer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            abstractsAnswer: (props.abstractsAnswer) ? props.abstractsAnswer : [],

        }
    }
    componentWillReceiveProps(nextProps) {

        if (!isEqual(this.state.abstractsAnswer, nextProps.abstractsAnswer)) {
            this.setState({
                abstractsAnswer: nextProps.abstractsAnswer
            })
        }
    }


    render() {
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.props.customWidth > 1000) {
            return (<div className="pubmed-main-right-answer box mb-4 white-box">
                <h2 className="semibold text-base m-0">Summary (based on top 5 papers)</h2>
                <div data-testid="synthesis-text" className="pubmed-main-right-result-main-answer-section">
                    {(this.state.abstractsAnswer.length > 0) ? <p>{this.state.abstractsAnswer?.map((dsitem, dsindex) => {
                        //dsitem.display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                       // dsitem.display_ans = dsitem.display_ans.replace(/<li><b>/g, '<li>');
                        return (<>
                            <PubMedAbstractsAnswerDisplayString key={`gen-ai-answering-result-main-answer${dsindex}`}
                                KeyPoints={dsitem.KeyPoints}
                                Summary={dsitem.Summary}
                                TableIndex={dsitem.index}
                                abstractsIndex={dsindex+1}
                                title={dsitem.title}
                               />
                                </>)
                    })}</p> : <p className="semibold text-base m-0">No summary available</p>}
                </div>
            </div>)
        }
    }
}

export default withRouter(PubMedRightGenAIAbstractsAnswer);